import { Controller } from "@hotwired/stimulus"

// Scrolls to a target element when clicked (mobile only)
export default class extends Controller {
  static values = {
    targetId: String,
    offset: { type: Number, default: 80 }
  }

  connect() {
    // Only make clickable on mobile
    if (window.innerWidth < 768) {
      this.element.style.cursor = 'pointer'
      this.element.addEventListener('click', this.scrollToTarget.bind(this))
    }
  }

  scrollToTarget(event) {
    // Only scroll on mobile
    if (window.innerWidth >= 768) return

    const targetId = this.targetIdValue
    if (!targetId) return

    const targetElement = document.getElementById(targetId)
    if (!targetElement) return

    const elementPosition = targetElement.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - this.offsetValue

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}


